import { render, staticRenderFns } from "./TableNewShop.vue?vue&type=template&id=165128f8&scoped=true"
import script from "./TableNewShop.vue?vue&type=script&lang=js"
export * from "./TableNewShop.vue?vue&type=script&lang=js"
import style0 from "./TableNewShop.vue?vue&type=style&index=0&id=165128f8&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165128f8",
  null
  
)

export default component.exports